import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-import-preview-modal',
  standalone: false,
  templateUrl: './import-preview-modal.html',
  styleUrl: './import-preview-modal.scss',
})
export class ImportPreviewModal {
  @Input() open = false;
  @Input() title = 'Confirmar importação';
  @Input() message: string | null = null;
  @Input() columns: string[] = [];
  @Input() rows: string[][] = [];
  @Input() primaryText = 'Importar';
  @Input() secondaryText = 'Cancelar';
  @Input() loading = false;
  @Input() primaryDisabled = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  protected get displayRows() {
    return this.rows ?? [];
  }
}
